// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tools_pad {
        width: 100%;
        height: 100%;
        padding: 20px;

        display: flex;
        justify-content: center;

        overflow: hidden;
}

.Tools_container {
        display: flex;
        flex-direction: column;

        width: 700px;
        background-color: #fff;
        border: 1px solid #e4e4e4;
        border-radius: 16px;

        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        overflow: hidden;
}

.Tools_header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 15px 20px 15px 27px;

        gap: 15px;

        border-bottom: 1px solid #e4e4e4;

        box-shadow: 0 0px 10px rgba(0, 0, 0, 0.025);

        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
}

.Tools_title {
        font-size: 30px;
        font-weight: 600;
        font-family: "Montserrat";

        background: -webkit-linear-gradient(right, #7600FF, #ff7c7c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
}

.Tools_searchContainer {
        display: flex;
}

.Tools_search {
        width: 400px;
        height: 40px;

        font-size: 16px;
        font-family: "Montserrat";

        padding: 0 20px;

        border: 1px solid #e4e4e4;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;

        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
}

.Tools_searchButton {
        border: 1px solid #e4e4e4;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;

        border-left: none;

        height: 40px;
        width: 40px;

        padding-right: 8.5px;
        padding-top: 2px;

        background-color: transparent;
}

.Tools_searchButton > img {
        height: 20px;
}

.Tools_sections {
        display: flex;
        flex-direction: column;

        overflow-y: auto;

        padding: 30px;
        padding-top: 20px;

        gap: 30px;

        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
}

.Tools_section {
        display: flex;
        flex-direction: column;
        gap: 15px;
}

.Tools_sectionTitle {
        font-size: 22px;
        font-weight: 600;
        font-family: "Montserrat";
}

.Tools_sectionContent {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
}

.Tools_feature {
        border: 1px solid #e4e4e4;
        border-radius: 8px;

        width: 275px;
        height: 90px;

        display: flex;

        gap: 15px;

        padding: 5px 15px;

        cursor: pointer;

        transition: transform ease 0.3s;
}
.Tools_feature:hover {
        transform: translateY(-2px);
}

.Tools_feature_left {
        display: flex;
        align-items: center;

        min-width: 70px;
}

.Tools_feature_left > img {
        width: 60px;
}

.Tools_feature_right {
        display: flex;
        flex-direction: column;
        justify-content: center;

        gap: 7px;

        height: 100%;
}

.Tools_feature_title {
        font-family: "Montserrat";
        font-size: 16px;
        font-weight: 600;
}

.Tools_feature_description {
        font-family: "Montserrat";
        font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/screens/Tools/Tools.css"],"names":[],"mappings":"AAAA;QACQ,WAAW;QACX,YAAY;QACZ,aAAa;;QAEb,aAAa;QACb,uBAAuB;;QAEvB,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,YAAY;QACZ,sBAAsB;QACtB,yBAAyB;QACzB,mBAAmB;;QAEnB,wCAAwC;;QAExC,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;QAE9B,4BAA4B;;QAE5B,SAAS;;QAET,gCAAgC;;QAEhC,2CAA2C;;QAE3C,4BAA4B;QAC5B,6BAA6B;AACrC;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,yBAAyB;;QAEzB,4DAA4D;QAC5D,6BAA6B;QAC7B,oCAAoC;AAC5C;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,YAAY;QACZ,YAAY;;QAEZ,eAAe;QACf,yBAAyB;;QAEzB,eAAe;;QAEf,yBAAyB;QACzB,4BAA4B;QAC5B,+BAA+B;;QAE/B,0BAA0B;QAC1B,6BAA6B;AACrC;;AAEA;QACQ,yBAAyB;QACzB,6BAA6B;QAC7B,gCAAgC;;QAEhC,iBAAiB;;QAEjB,YAAY;QACZ,WAAW;;QAEX,oBAAoB;QACpB,gBAAgB;;QAEhB,6BAA6B;AACrC;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,gBAAgB;;QAEhB,aAAa;QACb,iBAAiB;;QAEjB,SAAS;;QAET,+BAA+B;QAC/B,gCAAgC;AACxC;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,SAAS;AACjB;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,yBAAyB;AACjC;;AAEA;QACQ,aAAa;QACb,eAAe;QACf,SAAS;AACjB;;AAEA;QACQ,yBAAyB;QACzB,kBAAkB;;QAElB,YAAY;QACZ,YAAY;;QAEZ,aAAa;;QAEb,SAAS;;QAET,iBAAiB;;QAEjB,eAAe;;QAEf,+BAA+B;AACvC;AACA;QACQ,2BAA2B;AACnC;;AAEA;QACQ,aAAa;QACb,mBAAmB;;QAEnB,eAAe;AACvB;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,uBAAuB;;QAEvB,QAAQ;;QAER,YAAY;AACpB;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,yBAAyB;QACzB,eAAe;AACvB","sourcesContent":[".Tools_pad {\n        width: 100%;\n        height: 100%;\n        padding: 20px;\n\n        display: flex;\n        justify-content: center;\n\n        overflow: hidden;\n}\n\n.Tools_container {\n        display: flex;\n        flex-direction: column;\n\n        width: 700px;\n        background-color: #fff;\n        border: 1px solid #e4e4e4;\n        border-radius: 16px;\n\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n        overflow: hidden;\n}\n\n.Tools_header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        padding: 15px 20px 15px 27px;\n\n        gap: 15px;\n\n        border-bottom: 1px solid #e4e4e4;\n\n        box-shadow: 0 0px 10px rgba(0, 0, 0, 0.025);\n\n        border-top-left-radius: 16px;\n        border-top-right-radius: 16px;\n}\n\n.Tools_title {\n        font-size: 30px;\n        font-weight: 600;\n        font-family: \"Montserrat\";\n\n        background: -webkit-linear-gradient(right, #7600FF, #ff7c7c);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n}\n\n.Tools_searchContainer {\n        display: flex;\n}\n\n.Tools_search {\n        width: 400px;\n        height: 40px;\n\n        font-size: 16px;\n        font-family: \"Montserrat\";\n\n        padding: 0 20px;\n\n        border: 1px solid #e4e4e4;\n        border-top-left-radius: 20px;\n        border-bottom-left-radius: 20px;\n\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n}\n\n.Tools_searchButton {\n        border: 1px solid #e4e4e4;\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px;\n\n        border-left: none;\n\n        height: 40px;\n        width: 40px;\n\n        padding-right: 8.5px;\n        padding-top: 2px;\n\n        background-color: transparent;\n}\n\n.Tools_searchButton > img {\n        height: 20px;\n}\n\n.Tools_sections {\n        display: flex;\n        flex-direction: column;\n\n        overflow-y: auto;\n\n        padding: 30px;\n        padding-top: 20px;\n\n        gap: 30px;\n\n        border-bottom-left-radius: 16px;\n        border-bottom-right-radius: 16px;\n}\n\n.Tools_section {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n}\n\n.Tools_sectionTitle {\n        font-size: 22px;\n        font-weight: 600;\n        font-family: \"Montserrat\";\n}\n\n.Tools_sectionContent {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 20px;\n}\n\n.Tools_feature {\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n\n        width: 275px;\n        height: 90px;\n\n        display: flex;\n\n        gap: 15px;\n\n        padding: 5px 15px;\n\n        cursor: pointer;\n\n        transition: transform ease 0.3s;\n}\n.Tools_feature:hover {\n        transform: translateY(-2px);\n}\n\n.Tools_feature_left {\n        display: flex;\n        align-items: center;\n\n        min-width: 70px;\n}\n\n.Tools_feature_left > img {\n        width: 60px;\n}\n\n.Tools_feature_right {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n\n        gap: 7px;\n\n        height: 100%;\n}\n\n.Tools_feature_title {\n        font-family: \"Montserrat\";\n        font-size: 16px;\n        font-weight: 600;\n}\n\n.Tools_feature_description {\n        font-family: \"Montserrat\";\n        font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
